export default "__VITE_ASSET__ubwpLsjk__"